<template>
  <!-- ex-list .el -->
  <div class="el">
    <div class="el-search">
      <div>
        <input
          type="text"
          v-model="searchText"
          :placeholder="searchPlaceholder"
        />
        <span @click="searchPro">搜索</span>
      </div>
    </div>
    <Row type="flex" justify="space-between">
      <Col style="width: 260px">
        <filterCommon
          :filterCommonLoading="filterCommonLoading"
          :categoryList="categoryList"
          @changeCategory="changeCategory"
        ></filterCommon>
      </Col>
      <Col style="width: 920px">
        <div class="el-list-title">
          <span :class="listType == 0 ? 'active' : ''" @click="listType = 0"
            >产品</span
          >
          <span :class="listType == 1 ? 'active' : ''" @click="listType = 1"
            >企业</span
          >
          <!-- <span :class="listType == 0?'active':''" @click="listType=0;">产品（{{Total}}）</span>
          <span :class="listType == 1?'active':''" @click="listType=1;">企业（{{exTotal}}）</span> -->
        </div>
        <proItem
          v-if="listType == 0"
          :pageIndex="PageIndex"
          :pageSize="PageSize"
          :proList="proList"
          :proLoading="proLoading"
          :totalCount="Total"
          @getProList="getProList"
          @addProsuccess="addProsuccess"
          @cancelProsuccess="cancelProsuccess"
        ></proItem>
        <exItem
          v-if="listType == 1"
          :exList="exList"
          :pageIndex="exPageIndex"
          :pageSize="exPageSize"
          :exLoading="exLoading"
          :totalCount="exTotal"
          @getExList="getExList"
          @addsuccess="addsuccess"
          @cancelsuccess="cancelsuccess"
        ></exItem>
      </Col>
    </Row>
  </div>
</template>

<script>
import filterCommon from "@components/filter-common/filter-common.vue";
import exItem from "./components/ex-item.vue";
import proItem from "./components/pro-item.vue";
import { mapGetters, mapActions, mapMutations } from "vuex";

export default {
  name: "ex-list",
  data() {
    return {
      searchText: "",
      searchPlaceholder: "请输入要搜索的产品关键字",
      listType: 0, // 0 产品；1 展商
      PageIndex: 1, // 分页
      PageSize: 10, // 默认50个一页
      Total: 0,
      proList: [],
      categoryList: [],
      categoryId: "",
      exList: [],
      exPageIndex: 1,
      exPageSize: 10,
      exTotal: 0,
      filterCommonLoading: false,
      proLoading: false,
      exLoading: false,
    };
  },
  components: { filterCommon, exItem, proItem },
  computed: {
    ...mapGetters({
      exhibitionId: "getExhibitionId",
      searchType: "exhibitor/getSearchType",
      searchContent: "exhibitor/getSearchContent",
      caId: "exhibitor/getCaId",
      user: "getUser",
    }),
    condition() {
      let info = this.searchText;
      if (this.searchContent && this.searchType == 0) {
        info = this.searchContent;
        //分页获取条件
        return {
          body: {
            PageSize: this.PageSize,
            PageIndex: this.PageIndex,
            ExhibitionId: this.exhibitionId,
            Wheres: {
              type: 0,
              wheres: {
                WhereGroupOperator: 1, // 0是且 1是或
                Predicates: [
                  {
                    type: 1,
                    wheres: {
                      WhereOperator: 6,
                      Label: "Name",
                      Value: "%" + info + "%",
                    },
                  },
                  //产品适用渠道
                  {
                    type: 1,
                    wheres: {
                      WhereOperator: 6,
                      Label: "applicableChannels",
                      Value: "%" + info + "%",
                    },
                  },
                  //产品标签
                  {
                    type: 1,
                    wheres: {
                      WhereOperator: 6,
                      Label: "Tag",
                      Value: "%" + info + "%",
                    },
                  },
                  //产品应用科室
                  {
                    type: 1,
                    wheres: {
                      WhereOperator: 6,
                      Label: "AppliedSectionOffices",
                      Value: "%" + info + "%",
                    },
                  },
                  //产品认证
                  {
                    type: 1,
                    wheres: {
                      WhereOperator: 6,
                      Label: "Authentication",
                      Value: "%" + info + "%",
                    },
                  },
                  //质量体系认证
                  {
                    type: 1,
                    wheres: {
                      WhereOperator: 6,
                      Label: "CertificateQualities",
                      Value: "%" + info + "%",
                    },
                  },
                ],
              },
            },
          },
          topic: -1,
          apply: 0,
        };
      } else {
        //分页获取条件
        return {
          body: {
            PageSize: this.PageSize,
            PageIndex: this.PageIndex,
            ExhibitionId: this.exhibitionId,
            Wheres: {
              type: 0,
              wheres: {
                WhereGroupOperator: 1, // 0是且 1是或
                Predicates: [],
              },
            },
          },
          topic: -1,
          apply: 0,
        };
      }
    },
    exCondition() {
      let info = this.searchText;
      if (this.searchContent && this.searchType == 1||this.searchText) {
        info = this.searchContent||this.searchText;
        //分页获取条件
        return {
          PageSize: this.exPageSize,
          PageIndex: this.exPageIndex,
          ExhibitionId: this.exhibitionId,
          Wheres: {
            type: 0,
            wheres: {
              WhereGroupOperator: 1, // 0是且 1是或
              Predicates: [
                {
                  type: 1,
                  wheres: {
                    WhereOperator: 6,
                    Label: "ProductName",
                    Value: "%" + info + "%",
                  },
                },
                {
                  type: 1,
                  wheres: {
                    WhereOperator: 6,
                    Label: "Name",
                    Value: "%" + info + "%",
                  },
                },
                //产品适用渠道
                {
                  type: 1,
                  wheres: {
                    WhereOperator: 6,
                    Label: "ProductapplicableChannels",
                    Value: "%" + info + "%",
                  },
                },
                //产品标签
                {
                  type: 1,
                  wheres: {
                    WhereOperator: 6,
                    Label: "ProductTag",
                    Value: "%" + info + "%",
                  },
                },
                //产品应用科室
                {
                  type: 1,
                  wheres: {
                    WhereOperator: 6,
                    Label: "ProductAppliedSectionOffices",
                    Value: "%" + info + "%",
                  },
                },
                //产品认证
                {
                  type: 1,
                  wheres: {
                    WhereOperator: 6,
                    Label: "ProductAuthentication",
                    Value: "%" + info + "%",
                  },
                },
                //质量体系认证
                {
                  type: 1,
                  wheres: {
                    WhereOperator: 6,
                    Label: "ProductCertificateQualities",
                    Value: "%" + info + "%",
                  },
                },
              ],
            },
          },
        };
      } else {
        return {
          PageSize: this.exPageSize,
          PageIndex: this.exPageIndex,
          ExhibitionId: this.exhibitionId,
          Wheres: {
            type: 0,
            wheres: {
              WhereGroupOperator: 0, // 0是且 1是或
              Predicates: [],
            },
          },
        };
      }
    },
  },
  watch: {
    listType(val, oldVal) {
      if (val == 0) {
        this.searchPlaceholder = "请输入要搜索的产品关键字";
        //this.searchText = "";
        this.getPro();
      }
      if (val == 1) {
        this.searchPlaceholder = "请输入要搜索的展商关键字";
        console.log(this.exCondition.Wheres.wheres.Predicates,'erhifgeruifgeuryfgeufgyer8yfg')
        //this.searchText = "";
        this.getEx();
      }
    },
    searchContent(val, oldVal) {
      if (this.searchType == 0) {
        this.listType = 0;
        this.getPro();
      }
      if (this.searchType == 1) {
        this.listType = 1;
      
        this.getEx();
      }
    },
    // caId(val,oldVal) {
    //   // console.log(val);
    //   this.categoryId = val;
    //   this.setCaId("");
    //   if (this.searchType == 0) {
    //     this.listType = 0;
    //     this.getPro();
    //   }
    //   if (this.searchType == 1) {
    //     this.listType = 1;
    //     this.getEx();
    //   }
    // }
    $route(to, from) {
      if (this.$route.query.id) {
        this.categoryId = this.$route.query.id;
      } else {
        this.categoryId = "";
      }
      this.getPro();
      this.getCategory();
      this.getEx();
    },
    user(val, oldVal) {
      if (this.listType == 0) {
        this.getPro();
      }
      if (this.listType == 1) {
        this.getEx();
      }
    },
  },
  created() {
    if (this.$route.query.id) {
      this.categoryId = this.$route.query.id;
    }
    //this.searchPro()
    this.getPro();
    this.getCategory();
    this.getEx();
    if (this.searchType == 0) {
      this.listType = 0;
    }
    if (this.searchType == 1) {
      this.listType = 1;
    }
  },
  methods: {
    ...mapMutations({
      setSearchContent: "exhibitor/setSearchContent",
      setSearchType: "exhibitor/setSearchType",
      setCaId: "exhibitor/setCaId",
    }),
    ...mapActions({
      getProduct: "exhibitor/getProduct",
      getProductCategory: "exhibitor/getProductCategory",
      getRanking: "exhibitor/getRanking",
    }),
    searchPro() {
      this.setSearchContent("");
      console.log(this.setSearchContent, "setSearchContent");
      if (this.listType == 0) {
        this.condition.body.Wheres.wheres.Predicates = [
          {
            type: 1,
            wheres: {
              WhereOperator: 6,
              Label: "Name",
              Value: "%" + this.searchText + "%",
            },
          },
          //产品适用渠道
          {
            type: 1,
            wheres: {
              WhereOperator: 6,
              Label: "applicableChannels",
              Value: "%" + this.searchText + "%",
            },
          },
          //产品标签
          {
            type: 1,
            wheres: {
              WhereOperator: 6,
              Label: "Tag",
              Value: "%" + this.searchText + "%",
            },
          },
          //产品应用科室
          {
            type: 1,
            wheres: {
              WhereOperator: 6,
              Label: "AppliedSectionOffices",
              Value: "%" + this.searchText + "%",
            },
          },
          //产品认证
          {
            type: 1,
            wheres: {
              WhereOperator: 6,
              Label: "Authentication",
              Value: "%" + this.searchText + "%",
            },
          },
          //质量体系认证
          {
            type: 1,
            wheres: {
              WhereOperator: 6,
              Label: "CertificateQualities",
              Value: "%" + this.searchText + "%",
            },
          },
        ];
        this.getPro();
      }
      if (this.listType == 1) {
        this.exCondition.Wheres.wheres.Predicates = [
          {
            type: 1,
            wheres: {
              WhereOperator: 6,
              Label: "Name",
              Value: "%" + this.searchText + "%",
            },
          },
          {
            type: 1,
            wheres: {
              WhereOperator: 6,
              Label: "ProductName",
              Value: "%" + this.searchText + "%",
            },
          },
          //产品适用渠道
          {
            type: 1,
            wheres: {
              WhereOperator: 6,
              Label: "ProductapplicableChannels",
              Value: "%" + this.searchText + "%",
            },
          },
          //产品标签
          {
            type: 1,
            wheres: {
              WhereOperator: 6,
              Label: "ProductTag",
              Value: "%" + this.searchText + "%",
            },
          },
          //产品应用科室
          {
            type: 1,
            wheres: {
              WhereOperator: 6,
              Label: "ProductAppliedSectionOffices",
              Value: "%" + this.searchText + "%",
            },
          },
          //产品认证
          {
            type: 1,
            wheres: {
              WhereOperator: 6,
              Label: "ProductAuthentication",
              Value: "%" + this.searchText + "%",
            },
          },
          //质量体系认证
          {
            type: 1,
            wheres: {
              WhereOperator: 6,
              Label: "ProductCertificateQualities",
              Value: "%" + this.searchText + "%",
            },
          },
        ];
        this.getEx();
      }
    },
    changeCategory(e, name) {
      this.categoryId = e;
      console.log(this.categoryId, "iiiiiiii");
      if (this.listType == 0) {
        if (this.searchText && e) {
          console.log("类别和文字都有");
          this.condition.body.Wheres.wheres.WhereGroupOperator = 1;
          this.condition.body.Wheres.wheres.Predicates = [
            ({
              type: 1,
              wheres: {
                WhereOperator: 6,
                Label: "Name",
                Value: "%" + this.searchText + "%",
              },
            },
            //产品适用渠道
            {
              type: 1,
              wheres: {
                WhereOperator: 6,
                Label: "applicableChannels",
                Value: "%" + this.searchText + "%",
              },
            },
            //产品标签
            {
              type: 1,
              wheres: {
                WhereOperator: 6,
                Label: "Tag",
                Value: "%" + this.searchText + "%",
              },
            },
            //产品应用科室
            {
              type: 1,
              wheres: {
                WhereOperator: 6,
                Label: "AppliedSectionOffices",
                Value: "%" + this.searchText + "%",
              },
            },
            //产品认证
            {
              type: 1,
              wheres: {
                WhereOperator: 6,
                Label: "Authentication",
                Value: "%" + this.searchText + "%",
              },
            },
            //质量体系认证
            {
              type: 1,
              wheres: {
                WhereOperator: 6,
                Label: "CertificateQualities",
                Value: "%" + this.searchText + "%",
              },
            },
            {
              type: 1,
              wheres: {
                WhereOperator: 6,
                Label: "categories",
                Value: `%${this.categoryId}%`,
              },
            }),
          ];
        } else if (this.searchText && !e) {
          console.log("没有类别");
          this.condition.body.Wheres.wheres.WhereGroupOperator = 1;
          this.condition.body.Wheres.wheres.Predicates = [
            ({
              type: 1,
              wheres: {
                WhereOperator: 6,
                Label: "category",
                Value: "%" + this.searchText + "%",
              },
            },
            //产品适用渠道
            {
              type: 1,
              wheres: {
                WhereOperator: 6,
                Label: "applicableChannels",
                Value: "%" + this.searchText + "%",
              },
            },
            //产品标签
            {
              type: 1,
              wheres: {
                WhereOperator: 6,
                Label: "Tag",
                Value: "%" + this.searchText + "%",
              },
            },
            //产品应用科室
            {
              type: 1,
              wheres: {
                WhereOperator: 6,
                Label: "AppliedSectionOffices",
                Value: "%" + this.searchText + "%",
              },
            },
            //产品认证
            {
              type: 1,
              wheres: {
                WhereOperator: 6,
                Label: "Authentication",
                Value: "%" + this.searchText + "%",
              },
            },
            //质量体系认证
            {
              type: 1,
              wheres: {
                WhereOperator: 6,
                Label: "CertificateQualities",
                Value: "%" + this.searchText + "%",
              },
            }),
          ];
        } else {
          console.log("只有类别");
          this.condition.body.Wheres.wheres.Predicates = [];
          this.condition.body.Wheres.wheres.Predicates.push({
            type: 1,
            wheres: {
              WhereOperator: 6,
              Label: "category",
              Value: `%${this.categoryId}%`,
            },
          });
        }

        this.getPro();
      }
      //展商查询条件
      if (this.listType == 1) {
        if (this.searchText && e) {
          console.log(this.exCondition,"类别和文字都有");
          this.exCondition.Wheres.wheres.WhereGroupOperator = 1;
          this.exCondition.Wheres.wheres.Predicates = [
            {
              type: 1,
              wheres: {
                WhereOperator: 6,
                Label: "Name",
                Value: "%" + this.searchText + "%",
              },
            },
            {
              type: 1,
              wheres: {
                WhereOperator: 6,
                Label: "ProductName",
                Value: "%" + this.searchText + "%",
              },
            },
            //产品适用渠道
            {
              type: 1,
              wheres: {
                WhereOperator: 6,
                Label: "ProductapplicableChannels",
                Value: "%" + this.searchText + "%",
              },
            },
            //产品标签
            {
              type: 1,
              wheres: {
                WhereOperator: 6,
                Label: "ProductTag",
                Value: "%" + this.searchText + "%",
              },
            },
            //产品应用科室
            {
              type: 1,
              wheres: {
                WhereOperator: 6,
                Label: "ProductAppliedSectionOffices",
                Value: "%" + this.searchText + "%",
              },
            },
            //产品认证
            {
              type: 1,
              wheres: {
                WhereOperator: 6,
                Label: "ProductAuthentication",
                Value: "%" + this.searchText + "%",
              },
            },
            //质量体系认证
            {
              type: 1,
              wheres: {
                WhereOperator: 6,
                Label: "ProductCertificateQualities",
                Value: "%" + this.searchText + "%",
              },
            },
            {
              type: 4,
              wheres: {
                WhereOperator: 6,
                Label: "categories",
                Value: `%${this.categoryId}%`,
              },
            },
          ];
        } else if (this.searchText && !e) {
          console.log("没有类别");
          this.exCondition.Wheres.wheres.WhereGroupOperator = 1;
          this.exCondition.Wheres.wheres.Predicates = [
            {
              type: 1,
              wheres: {
                WhereOperator: 6,
                Label: "Name",
                Value: "%" + this.searchText + "%",
              },
            },
            {
              type: 1,
              wheres: {
                WhereOperator: 6,
                Label: "ProductName",
                Value: "%" + this.searchText + "%",
              },
            },
            //产品适用渠道
            {
              type: 1,
              wheres: {
                WhereOperator: 6,
                Label: "ProductapplicableChannels",
                Value: "%" + this.searchText + "%",
              },
            },
            //产品标签
            {
              type: 1,
              wheres: {
                WhereOperator: 6,
                Label: "ProductTag",
                Value: "%" + this.searchText + "%",
              },
            },
            //产品应用科室
            {
              type: 1,
              wheres: {
                WhereOperator: 6,
                Label: "ProductAppliedSectionOffices",
                Value: "%" + this.searchText + "%",
              },
            },
            //产品认证
            {
              type: 1,
              wheres: {
                WhereOperator: 6,
                Label: "ProductAuthentication",
                Value: "%" + this.searchText + "%",
              },
            },
            //质量体系认证
            {
              type: 1,
              wheres: {
                WhereOperator: 6,
                Label: "ProductCertificateQualities",
                Value: "%" + this.searchText + "%",
              },
            },
          ];
        } else {
          console.log("只有类别");
          this.exCondition.Wheres.wheres.Predicates = [];
          this.exCondition.Wheres.wheres.Predicates.push({
            type: 1,
            wheres: {
              WhereOperator: 6,
              Label: "category",
              Value: `%${this.categoryId}%`,
            },
          });
        }
        this.getEx();
      }
    },
    getProList(e) {
      if (e) {
        this.PageSize = e.pageSize;
        this.PageIndex = e.pageIndex;
      }
      this.getPro();
    },
    getExList(e) {
     
      if (e) {
        this.exPageSize = e.pageSize;
        this.exPageIndex = e.pageIndex;
      }
      this.getEx();
    },
    async getPro() {
      this.proLoading = true;
      this.listType = 0;
      let result = await this.getProduct(this.condition);
      if (result && result.items) {
        result.items.map((c) => {
          if (c.banner.search(/^\[/) !== -1) {
            c.banner = JSON.parse(c.banner);
          } else {
            c.banner = [c.banner];
          }
        });
        this.proLoading = false;
        this.proList = result.items;
        this.PageIndex = result.pageIndex;
        this.PageSize = result.pageSize;
        this.Total = result.totalCount;
      }
      console.log("proList：", this.proList);
    },
    async getCategory() {
      let categoryList = JSON.parse(sessionStorage.getItem("categoryList"));
      console.log(categoryList, "categoryList");
      if (categoryList && categoryList.length) {
        // categoryList.unshift({name:'全部',id:0})
        this.categoryList = categoryList;
      } else {
        this.filterCommonLoading = true;
        let list = await this.getProductCategory(this.exhibitionId);
        if (list) {
          this.categoryList = list;
          this.filterCommonLoading = false;
        }
      }
    },
    async getEx() {
      this.exLoading = true;
      let list = await this.getRanking(this.exCondition);
      if (list) {
        if (list && list.items) {
          list.items.map((c) => {
            if (c.listProduct) {
              c.listProduct.map((d) => {
                if (d.banner.search(/^\[/) !== -1) {
                  d.banner = JSON.parse(d.banner);
                } else {
                  d.banner = [d.banner];
                }
              });
            }
          });
        }
        this.exLoading = false;
        this.exList = list.items;
        this.exPageIndex = list.pageIndex;
        this.exPageSize = list.pageSize;
        this.exTotal = list.totalCount;
        console.log("exList：", this.exList);
      }
    },
    addsuccess(val) {
      this.exList.map((c) => {
        if (c.id == val.id) {
          c.isFollow = true;
        }
      });
    },
    cancelsuccess(val) {
      this.exList.map((c) => {
        if (c.id == val.id) {
          c.isFollow = false;
        }
      });
    },
    addProsuccess(val) {
      this.proList.map((c) => {
        if (c.id == val.id) {
          c.isFollow = true;
        }
      });
    },
    cancelProsuccess(val) {
      this.proList.map((c) => {
        if (c.id == val.id) {
          c.isFollow = false;
        }
      });
    },
  },
  destroyed() {
    this.setSearchContent("");
    this.setSearchType(0);
  },
};
</script>

<style scoped lang="scss">
.el {
  margin-top: 20px;
  .el-search {
    width: 1200px;
    background-color: #fff;
    height: 168px;
    margin: -20px 0 20px;
    padding-top: 60px;
    div {
      width: 900px;
      margin: 0 auto;
      height: 48px;
      display: flex;
      input {
        width: 816px;
        height: 100%;
        border: solid 1px #024c8b;
        border-radius: 5px 0 0 5px;
        outline: none;
        padding-left: 10px;
        font-size: 16px;
      }
      ::-webkit-input-placeholder {
        /* Chrome/Opera/Safari */
        color: #ccc;
        font-size: 16px;
      }
      ::-moz-placeholder {
        /* Firefox 19+ */
        color: #ccc;
        font-size: 16px;
      }
      :-ms-input-placeholder {
        /* IE 10+ */
        color: #ccc;
        font-size: 16px;
      }
      :-moz-placeholder {
        /* Firefox 18- */
        color: #ccc;
        font-size: 16px;
      }
      span {
        display: inline-block;
        width: 84px;
        height: 48px;
        background-color: #024c8b;
        text-align: center;
        line-height: 48px;
        color: #fff;
        font-size: 16px;
        border-radius: 0 5px 5px 0;
        cursor: pointer;
      }
    }
  }
  .el-list-title {
    width: 100%;
    height: 48px;
    border-bottom: 2px solid #024c8b;
    span {
      display: inline-block;
      width: 160px;
      height: 46px;
      background-color: #fff;
      text-align: center;
      line-height: 46px;
      font-size: 16px;
      color: #333;
      margin-right: 10px;
      cursor: pointer;
    }
    .active {
      background-color: #024c8b;
      color: #fff;
    }
  }
}
</style>
